module.exports = __webpack_public_path__ + "img/guali(3).de3117d9.jpg";